import { DialogContent, DialogOverlay } from '@reach/dialog';
import classNames from 'classnames';

import useStyles from './styles';
import IModal from './types';

export const MODAL_ROOT_ID = 'root';

import '@reach/dialog/styles.css';

function Modal({ className, backdropClassName, children, onClose }: IModal) {
  const classes = useStyles();

  return (
    <DialogOverlay className={classNames(classes.root, backdropClassName)} onDismiss={onClose}>
      <DialogContent aria-label="dialog" className={classNames(classes.modal, className)}>
        {children}
      </DialogContent>
    </DialogOverlay>
  );
}

export default Modal;
